import React from 'react'

import { AiOutlineLoading3Quarters } from "react-icons/ai";
import styled, { useTheme } from 'styled-components';
import Text from '../Text';

const Container = styled.div`
  position: ${({position}) => position};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  background: #fffc;

  p {
    margin-left: 6px;
  }
`;

const Loading = ({ position = 'absolute', text = null }) => {
  const { colors } = useTheme();
  return (
    <Container position={position}>
      <AiOutlineLoading3Quarters fill={colors.primary} size={24} className="rotating" />
      {Boolean(text) && <Text variant="regular">{text}</Text>}
    </Container>
  )
}

export default Loading
